import React, { FC } from 'react'

import { IconWebProtectionProps } from './IconWebProtection.types'
import * as Styled from './styles/IconWebProtection.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWebProtection: FC<IconWebProtectionProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWebProtectionProps['size'],
  isResponsive = false,
}: IconWebProtectionProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M43.02 9.824c0 24.117-15.54 31.797-18.54 33.125-.312.14-.668.14-.98 0-3-1.328-18.531-9-18.531-33.125 0-3.554 6.793 2.48 18.156-4.625a1.645 1.645 0 0 1 1.75 0C29.328 7.984 33.085 9.012 36 9.07h7.02v.754Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M15.71 30.895c.95-4.442 4.302-7.723 8.29-7.723 3.988 0 7.34 3.281 8.29 7.723'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M28.828 17.871A4.826 4.826 0 0 1 24 22.7a4.826 4.826 0 0 1-4.828-4.828A4.83 4.83 0 0 1 24 13.04h4.828v4.832Z'
          stroke='#E60000'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconWebProtection
